<template>
  <div class="pulse-promo">
    <div class="pulse-promo__image">
      <img :src="PulseImage" alt="Pulse" />
    </div>
    <div class="pulse-promo__head">
      <h2 class="pulse-promo__title" v-html="$t('pulse.promo.title')" />
      <div class="pulse-promo__head-image">
        <img :src="PulseImage" alt="Pulse" />
      </div>
      <p
        class="pulse-promo__description"
        v-html="$t('pulse.promo.description')"
      />
    </div>
    <ul class="pulse-promo__list">
      <li
        v-for="option in pulsePromoOptions"
        :key="option.id"
        class="pulse-promo__item"
      >
        <div class="pulse-promo__item-icon">
          <component :is="option.icon" class="icon" />
        </div>
        <div class="pulse-promo__item-content">
          <p class="pulse-promo__item-title" v-html="$t(option.title)" />
          <p
            class="pulse-promo__item-description"
            v-html="$t(option.description)"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import PulseImage from '~/assets/images/pulse/pulse.png';
const pulsePromoIcons = ['calendar-bold', 'compas-bold', 'gear'];

const pulsePromoOptions = computed(() => {
  const options = [];

  for (let i = 1; i <= 3; i++) {
    options.push({
      id: i,
      title: `pulse.promo.options.${i}.title`,
      description: `pulse.promo.options.${i}.description`,
      icon: pulsePromoIcons[i - 1]
        ? resolveComponent(`svgo-${pulsePromoIcons[i - 1]}`)
        : null,
    });
  }

  return options;
});
</script>
